/**
 * CreateStore queries
 */
import gql from 'graphql-tag'

export const desginsQuery = gql`
  query GetDesigns(
    $limit: Int
    $offset: Int
    $userId: String
    $proDesign: Boolean
  ) {
    designsResult: myDesigns(
      limit: $limit
      offset: $offset
      userId: $userId
      proDesign: $proDesign
      fromStore: true
    ) {
      fullCount
      designs {
        id
        code
        name
        shared
        image
        shortId: short_id
        proDesign: pro_design
        imported
        proCertified: pro_certified
        qualityWarning: quality_warning
        requirePrintApproval: require_print_approval
        printApproved: print_approved
        isDraft: is_draft
        createdAt: created_at
        product {
          id
          code
          active
          yotpoId: yotpo_id
          type: name
          weight
          onlyProDesign: only_pro_design
          description: short_description
          priceRange {
            quantity
            price
            abbreviation
            shortName: short_name
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/LockerModal/data.ts